import { render, staticRenderFns } from "./EmployeeDetail.vue?vue&type=template&id=3e4ea84f&scoped=true&"
import script from "./EmployeeDetail.vue?vue&type=script&lang=js&"
export * from "./EmployeeDetail.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeDetail.vue?vue&type=style&index=0&id=3e4ea84f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4ea84f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCol,VContainer,VDataTable,VIcon})
